import { render } from "./Personal.vue?vue&type=template&id=fc28c5aa&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"

import "./Personal.vue?vue&type=style&index=0&id=fc28c5aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-fc28c5aa"

export default script